import { Link } from "react-router-dom";
import { ArrowUpRight, Sparkles } from "lucide-react";
import Reveal from "./Reveal";
import { useLang } from "../i18n/i18n";

const STRIP = [
  { src: "https://images.unsplash.com/photo-1745237826674-1fb299b72913?crop=entropy&cs=srgb&fm=jpg&q=80&w=600", alt: "Works of art" },
  { src: "https://images.unsplash.com/photo-1657214005798-86b35114fc0b?crop=entropy&cs=srgb&fm=jpg&q=80&w=600", alt: "Collectible coins" },
  { src: "https://images.unsplash.com/photo-1595923533867-ff8a01335ff9?crop=entropy&cs=srgb&fm=jpg&q=80&w=600", alt: "Watches" },
  { src: "https://images.unsplash.com/photo-1787741045490-7a0969d24261?crop=entropy&cs=srgb&fm=jpg&q=80&w=600", alt: "Stamps" },
  { src: "https://images.unsplash.com/photo-1626784214536-d859187e0bd0?crop=entropy&cs=srgb&fm=jpg&q=80&w=600", alt: "Jewelry" },
  { src: "https://images.unsplash.com/photo-1516456277948-c81597a8d1be?crop=entropy&cs=srgb&fm=jpg&q=80&w=600", alt: "Collectibles" },
];

export default function CollectionBanner() {
  const { t } = useLang();
  return (
    <section className="mx-auto max-w-7xl px-5 sm:px-8 py-6" data-testid="collection-banner-section">
      <Reveal>
        <Link
          to="/nous-achetons"
          data-testid="collection-banner"
          className="group relative block overflow-hidden rounded-3xl border border-gold/20"
        >
          <div className="flex h-48 sm:h-56">
            {STRIP.map((img) => (
              <img
                key={img.src}
                src={img.src}
                alt={img.alt}
                className="min-w-0 flex-1 h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
            ))}
          </div>
          <div className="absolute inset-0 bg-gradient-to-r from-ink/95 via-ink/60 to-ink/30" />
          <div className="absolute inset-0 flex flex-col justify-center px-7 sm:px-12">
            <p className="inline-flex items-center gap-2 text-[11px] tracking-[0.35em] uppercase text-gold">
              <Sparkles size={13} /> {t("banner.eyebrow")}
            </p>
            <p className="mt-3 font-display text-xl sm:text-3xl text-cream leading-snug max-w-xl">{t("banner.items")}</p>
            <span className="mt-5 inline-flex items-center gap-2 w-fit rounded-full bg-gold px-5 py-2.5 text-[13px] font-semibold text-ink transition-all group-hover:bg-goldlight group-hover:shadow-[0_0_28px_rgba(212,175,55,0.4)]">
              {t("banner.cta")} <ArrowUpRight size={15} />
            </span>
          </div>
        </Link>
      </Reveal>
    </section>
  );
}
